import { z } from 'zod';
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
export const passwordPolicySchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `must be at least ${PASSWORD_MIN_LENGTH} characters`)
    .max(PASSWORD_MAX_LENGTH, `must be at most ${PASSWORD_MAX_LENGTH} characters`);
export const passwordLoginRequestSchema = z.object({
    email: z.email().max(254),
    password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
    locale: z.enum(['en', 'de']).optional(),
});
export const setPasswordRequestSchema = z.object({
    password: passwordPolicySchema,
});
export const offerPasswordResponseSchema = z.object({
    status: z.literal('offer-password'),
});
//# sourceMappingURL=password.js.map